import { useData } from "@hooks/useData";
import { iReportProPublication, ReportProPublication } from "@models/ReportProPublication";
import http from '@core/fetch';
import { components } from "@apiSchema";

async function getReportProNewReleases (): Promise<iReportProPublication[]> {
    const response: components["schemas"]["ReportProPublicationClientWrapper"] = await http.get('reportpro new releases');
    return (response?.data || []).map(apiModel => new ReportProPublication({ apiModel }));
}

export function useReportProNewReleases() {
    return useData([], getReportProNewReleases);
}